<template>
    <div>

        <!-- Tabs and struct -->

        <trax-ui-vertical-dynamic-tabs :tabs="tabs" :id="id+'-tabs'" :bus="bus" class="pt-3 pb-3">
            <enac-custom-behavioural-indicator-edit-struct :id="id" :bus="bus" :endpoint="endpoint" 
                :new-item-label="lang.polaris.common.new_indicator" 
                :new-category-label="lang.polaris.common.new_indicator_set" 
                :new-title-label="lang.polaris.training.new_competency_title" 
                :index-id="indexId" drag="1">
            </enac-custom-behavioural-indicator-edit-struct>
        </trax-ui-vertical-dynamic-tabs>

        <!-- Editing modal -->

        <trax-ui-modal-default :id="id+'-edit'" :bus="bus">
            <enac-custom-behavioural-indicator-edit-form :id="id+'-edit'" :toastr-id="id+'-toastr'" :bus="bus" 
                :endpoint="endpoint" :item-rows="3">
            </enac-custom-behavioural-indicator-edit-form>
        </trax-ui-modal-default>

        <!-- Delete confirm modal -->

        <trax-ui-modal-confirm :id="id+'-delete'" :title="lang.polaris.form.deletion" :bus="bus">
            {{ lang.polaris.form.confirm_delete_q }}
        </trax-ui-modal-confirm>

        <!-- Toastr -->

        <trax-ui-toastr :id="id+'-toastr'" :bus="bus" passed-label="1" no-progress="1">
        </trax-ui-toastr>

    </div>
</template>

<script>
    export default {
    
        props: {
            indexId: null,
            id: {default: 'trax-training-competency-item'}
        },
    
        data: function() {
            return {
                lang: lang,
                endpoint: app_url+"polaris/api/front/competency-items",
                tabs: data.competency_item_types_select,
                bus: new Vue()
            }
        }
    }
</script>
